export default __webpack_public_path__ + "static/media/stackd-logo-title.192fcd6e.png";